import React, { Component } from 'react';
import { Container, Row, Button, ListGroup, ListGroupItem, Table } from 'reactstrap';
import { purchasePackageDetail } from "../../graphqlDic";
import { compose, graphql } from 'react-apollo';
import { ToastContainer, toast } from 'react-toastify';
import './Scoin.css';
import { connect } from 'react-redux';
import { loggedInUser } from './../../actions/user';
import { Link } from 'react-router-dom';
import { callChange } from './../../helpers/ApiPayment';

class PackageDetail extends Component {

	constructor(props) {
		super(props);
		this.state = {
			packageItem: null,
			packageDetailSelected: null,
			packageDetailSelectedIndex: -1,
		}
	}

	notify = (msg) => toast.info(msg);

	componentWillReceiveProps(nextProps) {
		if (this.state.packageDetailSelected === null) { // set default after load getPackageById
			if (nextProps.getPackageById.getPackageById && nextProps.getPackageById.getPackageById.package_details.length > 0) {
				this.setState({
					packageDetailSelected: nextProps.getPackageById.getPackageById.package_details[0],
					packageDetailSelectedIndex: 0
				})
			}
		}
	}

	handleOnClickPackageDetail = (item, index) => {
		this.setState({
			packageDetailSelected: item,
			packageDetailSelectedIndex: index
		})
	}

	handlePayment = () => {
		let { packageDetailSelected } = this.state;
		let { user_info } = this.props;

		let package_id = this.props.match.params.id;
		if (packageDetailSelected) {
			if (user_info.scoin >= packageDetailSelected.scoin) {
				this.props.purchasePackageDetail({
					variables: {
						user_id: parseInt(user_info.id, 10),
						package_detail_id: parseInt(packageDetailSelected.id, 10),
					}
				}).then(() => {
					let data = {};
					data.email = user_info.email;
					data.value = -Math.abs(packageDetailSelected.scoin); // negative-number
					data.ordercode = Date.now();
					let result = callChange(data);
						result.then(
							window.location.href = (`/purchased-package/${package_id}/${packageDetailSelected.id}`)
						).catch(console.log)
				})
				.catch(error => {
					console.log(error)
				});
			} else {
				this.notify("Tài khoản của bạn không đủ scoin!");
			}
		} else {
			this.notify("Bạn vui lòng chọn gói trước khi mua!");
		}
	}

	generatePackageDetail = (packageDetail, selected) => {
		return packageDetail.map((item, index) => {
			return (
				<div className="col-md-3 box_purchase_plan" key={index}>
					<a onClick={() => this.handleOnClickPackageDetail(item, index)} role="button">
						<div className={parseInt(index, 10) === parseInt(selected, 10) ? "bundle-item checked" : "bundle-item"} plan={745} value={20}>
							<h2 className="bundle-item-title">{item.title}</h2>
							<p className="bundle-item-price">{item.scoin + " Scoin"}</p>
							<i className="fa fa-check-circle checkstatus fa-2x" aria-hidden="true"></i>
						</div>
					</a>
				</div>
			)
		})
	}

	generateDateFrom = (user_package, packageItem) => {
		let package_ids = [...user_package].map(item => item.package.id);

		let enddayTimeStamp = Date.now();
		let index = package_ids.indexOf(packageItem.id);
		if (index !== -1) {
			enddayTimeStamp = new Date(user_package[index].endday).getTime(); // convert to timestamp
		}
		return new Date(enddayTimeStamp).toLocaleString(); // convert to ISO datetime
	}

	generateDateTo = (user_package, packageItem, day) => {
		let package_ids = [...user_package].map(item => item.package.id);

		let enddayTimeStamp = Date.now();
		let index = package_ids.indexOf(packageItem.id);
		if (index !== -1) {
			enddayTimeStamp = new Date(user_package[index].endday).getTime(); // convert to timestamp
		}
		enddayTimeStamp += day * 24 * 60 * 60000;
		return new Date(enddayTimeStamp).toLocaleString(); // convert to ISO datetime
	}

	generateShortcutPurchaseScoin() {
		let { packageDetailSelected } = this.state;
		let { user_info } = this.props;
		if (packageDetailSelected && user_info.scoin < packageDetailSelected.scoin) {
			return (
				<Link to={'/scoin'} className="shortcut-purchase-scoin-button btn btn-secondary" >
					Mua Scoin
				</Link>
			)
		}
		return null;
	}
	generateDiscount(packageItem, packageDetailSelected) {
		if (packageDetailSelected && packageDetailSelected.discount) {
			let discount = packageDetailSelected.discount;
			return (
				<b className="text-center pull-left" style={{paddingBottom: "15px"}}>
					Gói {packageDetailSelected.title} được chiết khấu {discount.percent}% từ {packageItem.base_value * packageDetailSelected.day} 
					scoin còn {packageDetailSelected.scoin} scoin 
					trong thời gian từ ngày {new Date(discount.from).toLocaleString()} đến ngày {new Date(discount.to).toLocaleString()}
				</b>
			)
		}
		return null;
	}

	render() {
		if (this.props.getPackageById.loading) return "Loading...";
		if (this.props.getPackageById.error) return `Error! ${this.props.getPackageById.error.message}`;
		let packageItem = this.props.getPackageById.getPackageById;
		let { user_info } = this.props;
		let user_package = user_info.user_package;
		let { packageDetailSelectedIndex, packageDetailSelected } = this.state;

		return (
			<div className="bg-black">
				<ToastContainer />
				<div className="select-bundle-vip">
					<Container>
						<Row>
							<div className="col-xs-12 col-md-6 col-md-offset-3">
								<div className="boxes">
									<div className="box past active">
										<div className="inner active">
											<div className="icon"><i className="fa fa-credit-card-alt fa-2x" aria-hidden="true"></i></div>
											<p>Chọn gói</p>
										</div>
									</div>
									<div className="box past">
										<div className="inner active">
											<div className="icon"><i className="fa fa-credit-card fa-2x" aria-hidden="true"></i></div>
											<p>Thanh toán</p>
										</div>
									</div>
									<div className="box past">
										<div className="inner">
											<div className="icon"><i className="fa fa-check-square-o fa-2x" aria-hidden="true"></i></div>
											<p>Hoàn thành</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xs-12">
								<h1 className="scoin-title">Chọn gói Thời Gian</h1>
								<Row>
									{this.generatePackageDetail(packageItem.package_details, packageDetailSelectedIndex)}
								</Row>
							</div>
							<div className="col-xs-12">
								<div className="list-payment-types">
									<h1 className="scoin-title">Thông tin xác nhận</h1>
									<Row>
										<div className="col-xs-12 col-md-6 col-md-offset-3">
											<div className="confirm_info_block">
												{ this.generateDiscount(packageItem, packageDetailSelected) }
												<Table borderless>
													<tbody>
														<tr>
															<th scope="row">Tên tài khoản:</th>
															<td><strong>{user_info.fullname ? user_info.fullname : user_info.username}</strong></td>
														</tr>
														<tr>
															<th scope="row">Dịch vụ:</th>
															<td><strong>{packageItem.title}</strong></td>
														</tr>
														<tr>
															<th scope="row">Gói sử dụng:</th>
															<td><strong>{packageDetailSelected ? packageDetailSelected.scoin + " Scoin" : null}</strong></td>
														</tr>
														<tr>
															<th scope="row">Thời hạn:</th>
															<td><strong>{packageDetailSelected ? packageDetailSelected.day + " ngày" : null}</strong></td>
														</tr>
														{user_package && user_package.length > 0 ? <tr>
															<th scope="row">Gia hạn từ:</th>
															<td><strong>{this.generateDateFrom(user_package, packageItem)}</strong></td>
														</tr> : null}
														{user_package && user_package.length > 0 ? <tr>
															<th scope="row">Gia hạn đến:</th>
															<td><strong>{packageDetailSelected ? this.generateDateTo(user_package, packageItem, packageDetailSelected.day) : null}</strong></td>
														</tr> : null}
													</tbody>
												</Table>
											</div>
										</div>
									</Row>
								</div>
								<div className="list-payment-types">
									<h1 className="scoin-title">Hình thức thanh toán</h1>
									<div className="payment-details">
										<div className="text-uppercase user-info-heading"><i className="fa fa-lg fa-check-square text-danger"></i>{' '}Sử dụng Scoin</div>
										<ListGroup>
											<ListGroupItem><strong>- SỐ DƯ TÀI KHOẢN: </strong>
												<span className="text-danger">{user_info.scoin} scoin</span>{' '}
												{this.generateShortcutPurchaseScoin()}
											</ListGroupItem>
										</ListGroup>
										{JSON.stringify(user_info) === '{}' ?
											<Link to='/login' className="payment-button btn btn-secondary">Đăng Nhập</Link>
											: <Button onClick={this.handlePayment} className="payment-button">Thanh Toán</Button>
										}
									</div>
								</div>
							</div>
						</Row>
					</Container >
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		user_info: state.root.users
	}
}

export default compose(graphql(
	purchasePackageDetail, {
		name: 'purchasePackageDetail'
	})
)(connect(mapStateToProps, { loggedInUser })(PackageDetail));


// WEBPACK FOOTER //
// ./src/components/Scoin/PackageDetail.js